
import EditForm from '@/components/Management/Store/EditForm';

export default {
  components: {
    EditForm
  }
};
